export default "__VITE_ASSET__4d43a14a__"